import PropTypes from "prop-types";

const Button = ({
  loading = false,
  disabled = false,
  children,
  sx = "",
  type = "button",
  variant = "primary",
  size = "md",
  ...props
}) => {
  const baseStyles =
    "font-medium transition duration-300 ease-in-out focus:ring-2 focus:outline-none relative inline-flex items-center justify-center";

  const sizeStyles = {
    sm: "px-3 py-1.5 text-sm rounded",
    md: "px-4 py-2 text-base rounded shadow-sm",
    lg: "px-8 py-2.5 text-base rounded-lg shadow-sm",
    pill: "px-12 py-3 text-base rounded-full shadow-sm",
  };

  const spinnerSizeStyles = {
    sm: "w-3.5 h-3.5",
    md: "w-4 h-4",
    lg: "w-5 h-5",
    pill: "w-5 h-5",
  };

  const variantStyles = {
    primary: "bg-primary hover:bg-primary800 text-inverse focus:ring-primary500",
    destructive: "text-error bg-error-soft hover:bg-error-soft-hover focus:ring-error",
    ghost: "text-primary500 hover:text-primary focus:ring-primary500",
    black: "bg-dark hover:bg-dark text-inverse focus:ring-text-muted",
  };

  const disabledStyles = loading || disabled ? "opacity-50 cursor-not-allowed" : "";

  return (
    <button
      className={`${baseStyles} ${sizeStyles[size] || sizeStyles.md} ${variantStyles[variant] || variantStyles.primary} ${disabledStyles} ${sx}`.trim()}
      disabled={loading || disabled}
      type={type}
      aria-busy={loading}
      {...props}
    >
      {loading && (
        <span
          className={`${spinnerSizeStyles[size] || spinnerSizeStyles.md} mr-2 shrink-0 rounded-full border-2 border-current border-t-transparent animate-spin`}
          aria-hidden="true"
        />
      )}
      {children}
    </button>
  );
};

Button.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  sx: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.oneOf(["primary", "destructive", "ghost", "black"]),
  size: PropTypes.oneOf(["sm", "md", "lg", "pill"]),
};

export default Button;
